import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { formatMoeda } from '@fiodecobre/shared';
import { useAlertaFaixa } from './alertas/AlertasContexto';

interface Item {
  id: number;
  caixa_nome: string;
  divergencia_abertura: string;
  operador_abertura_nome: string | null;
}
interface Resumo {
  qtd: number;
  total_falta: string | number;
  total_sobra: string | number;
  itens: Item[];
}

const POLLING_MS = 5 * 60 * 1000;

// Faixa in-system (igual a de contas a pagar vencendo/vencido) pras gavetas que abriram com
// divergencia (contado != troco deixado no fechamento anterior). Ao contrario do contas a pagar,
// NAO some sozinha nem da pra dispensar: fica no ar ate o admin/gerente RESOLVER (na aba Sessoes),
// porque dinheiro sumido nao "se paga sozinho".
export function AlertaCaixaDivergenciaBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);

  const podeVer = usuario && ['admin', 'gerente'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/caixa/divergencias-abertura');
        if (!cancelado) setResumo(r);
      } catch {}
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && resumo && resumo.qtd > 0);
  const recolhido = useAlertaFaixa(
    'caixa-divergencia',
    ativo ? { rotulo: 'Caixa', bg: '#ef4444', borda: '#b91c1c', qtd: resumo!.qtd } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  const falta = Number(resumo.total_falta);
  const sobra = Number(resumo.total_sobra);

  return (
    <div
      style={{
        background: '#ef4444',
        borderLeft: '4px solid #b91c1c',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/caixa')}
    >
      <AlertTriangle size={16} />
      <span style={{ fontWeight: 600 }}>Caixa:</span>
      <span>
        {resumo.qtd} gaveta{resumo.qtd === 1 ? '' : 's'} abriu com diferença
        {falta > 0.005 && <> · faltou {formatMoeda(falta)}</>}
        {sobra > 0.005 && <> · sobrou {formatMoeda(sobra)}</>}
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Ver e resolver</span>
    </div>
  );
}
